// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Wbpt","actionsCol":"EnrolledClinics_actionsCol__2P-10"};